import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import StyledButtonProps from "../useInterfaces/MDButtonInterface";

export default styled(Button)<StyledButtonProps>(({ theme, ownerState }) => {
  
  const palette = theme?.palette;
  const functions = theme?.functions;
  const borders = theme?.border;
  const boxShadows = theme?.boxShadows;

  const { color="white", variant="", size="medium", circular=false, iconOnly=false, textTransform="none",darkMode=false, isActive=false } = ownerState|| {};
  const { white, text, dark, transparent, gradients, grey, light } = palette|| {};
  const { boxShadow, linearGradient, pxToRem, rgba } = functions|| {};
  const { borderRadius } = borders || {};
  const { colored } = boxShadows|| {};
  const sizeMap: Record<"small" | "medium" | "large", keyof typeof theme.typography.size> = {
    small: 'xs',
    medium: 'md',
    large: 'lg',
  };
//  console.log(borderRadius)
  //console.log('iconOnly')
  const ElFontSize = ownerState && ownerState.size ? theme.typography.size[sizeMap[ownerState.size]] : theme.typography.size.md;
  //console.log(theme.typography.size[sizeMap[ownerState.size]])
  //console.log(theme.typography.size.md)
  // styles for the button with variant="contained"
  const containedStyles = () => {
    // background color value
    const backgroundValue = palette[color] ? palette[color].main : white.main;

    // backgroundColor value when button is focused
    const focusedBackgroundValue = palette[color] ? palette[color].focus : white.focus;

    // backgroundColor value when button is disabled
    const disabledbackgroundColor = palette[color] ? palette[color].disabled : transparent.main;
    const disabledborderColor =  palette[color] ? palette.grey[400]:white.main;

    //5d6e84
    // boxShadow value
    const boxShadowValue = colored[color]
      ? `${boxShadow([0, 3], [3, 0], palette[color].main, 0.15)}, ${boxShadow(
          [0, 3],
          [1, -2],
          palette[color].main,
          0.2
        )}, ${boxShadow([0, 1], [5, 0], palette[color].main, 0.15)}`
      : "none";

    // boxShadow value when button is hovered
    const hoveredBoxShadowValue = colored[color]
      ? `${boxShadow([0, 14], [26, -12], palette[color].main, 0.4)}, ${boxShadow(
          [0, 4],
          [23, 0],
          palette[color].main,
          0.15
        )}, ${boxShadow([0, 8], [10, -5], palette[color].main, 0.2)}`
      : "none";

    // color value
    let colorValue = white.main;
    if (!darkMode && (color === "white" || color === "light" || !palette[color])) {
      colorValue = text.main;
    } else if (darkMode && (color === "white" || color === "light" || !palette[color])) {
      colorValue = grey[600];
    }
    // color value when button is focused
    let focusedColorValue = white.main;

    if (color === "white") {
      focusedColorValue = text.main;
    } else if (color === "primary" || color === "error" || color === "dark") {
      focusedColorValue = white.main;
    }

     // color value when button is disabled
     let disabledcolorValue = palette[color] ? palette.grey[600]:white.main;
     if (!darkMode && (color === "white" || color === "light" || !palette[color])) {
      disabledcolorValue = text.main;
     } else if (darkMode && (color === "white" || color === "light" || !palette[color])) {
      disabledcolorValue = grey[600];
     }

    return {
      background: backgroundValue,
      color: colorValue,
      boxShadow: boxShadowValue,
      textTransform:textTransform,

      "&:hover": {
        backgroundColor: focusedBackgroundValue,
        boxShadow: hoveredBoxShadowValue,
        color: colorValue,
      },

      "&:focus:not(:hover)": {
        backgroundColor: focusedBackgroundValue,
        color: colorValue,
        boxShadow: palette[color]
          ? boxShadow([0, 0], [0, 3.2], palette[color].main, 0.5)
          : boxShadow([0, 0], [0, 3.2], white.main, 0.5),
      },

      "&:disabled": {
        backgroundColor: disabledbackgroundColor,
        color: disabledcolorValue,
        borderColor: disabledborderColor,
        borderWidth: "1px",
        borderStyle: "solid",

      },
    };
  };

  // styles for the button with variant="outlined"
  const outliedStyles = () => {

    // background color value
    const backgroundValue = color === "white" ? rgba(white.main, 0.1) : transparent.main;

    // color value
    const colorValue = palette[color] ? palette[color].main : white.main;

    // boxShadow value
    const boxShadowValue = palette[color]
      ? boxShadow([0, 0], [0, 3.2], palette[color].main, 0.5)
      : boxShadow([0, 0], [0, 3.2], white.main, 0.5);

    // border color value
    let borderColorValue = palette[color] ? palette[color].main : rgba(white.main, 0.75);

    if (color === "white") {
      borderColorValue = rgba(white.main, 0.75);
    }

    return {
      background: backgroundValue,
      color: colorValue,
      borderColor: borderColorValue,
      textTransform:textTransform,

      "&:hover": {
        background: transparent.main,
        //background: "green",
        borderColor: colorValue,
        color: white.main,
      },

      "&:focus:not(:hover)": {
        //background: "yellow",
        background: transparent.main,
        //boxShadow: boxShadowValue,
        color: white.main,
      },

      "&:active:not(:hover)": {
        backgroundColor: colorValue,
        color: white.main,
        opacity: 0.85,
      },

      "&:disabled": {
        background: "blue",
        color: colorValue,
        borderColor: colorValue,
      },
    };
  };

  // styles for the button with variant="gradient"
  const gradientStyles = () => {
    // background value
    const backgroundValue =
      color === "white" || !gradients[color]
        ? white.main
        : linearGradient(gradients[color].main, gradients[color].state);
    // boxShadow value
    const boxShadowValue = colored[color]
      ? `${boxShadow([0, 3], [3, 0], palette[color].main, 0.15)}, ${boxShadow(
          [0, 3],
          [1, -2],
          palette[color].main,
          0.2
        )}, ${boxShadow([0, 1], [5, 0], palette[color].main, 0.15)}`
      : "none";

    // boxShadow value when button is hovered
    const hoveredBoxShadowValue = colored[color]
      ? `${boxShadow([0, 14], [26, -12], palette[color].main, 0.4)}, ${boxShadow(
          [0, 4],
          [23, 0],
          palette[color].main,
          0.15
        )}, ${boxShadow([0, 8], [10, -5], palette[color].main, 0.2)}`
      : "none";

    // color value
    let colorValue = 'black';
//    console.log(text.main +'text.main')
    if (color === "white") {
      colorValue = text.main;
    } else if (color === "light") {
      colorValue = gradients.dark.state;
    }else if (color === "dark") {
      colorValue = gradients.light.state;
    }
//    console.log(colorValue +'colorValue')
    let colorHoverValue = "";
    if (color === "info") {
      colorHoverValue = dark.main;
    }
    
    return {
      background: backgroundValue + '!important',
      boxShadow: boxShadowValue,
      color:colorValue,
      textTransform:textTransform,
      fontSize:ElFontSize,
      borderRadius:borderRadius.xxl,

      "&:hover": {
        boxShadow: hoveredBoxShadowValue,
        color: colorHoverValue,
      },

      "&:focus:not(:hover)": {
        boxShadow: boxShadowValue,
      },

      "&:disabled": {
        background: backgroundValue,
        color: colorValue,
      },
    };
  };

  // styles for the button with variant="text"
  const textStyles = () => {
    // color value
    const colorValue = palette[color] ? palette[color].main : white.main;
    // color value when button is focused
    const focusedColorValue = palette[color] ? palette[color].focus : white.focus;
    const backgroundValue = color === "white" ? rgba(white.main, 0.1) : transparent.main;
    const boxShadowValue = palette[color]
      ? boxShadow([0, 0], [0, 1], palette[color].main, 0.5)
      : boxShadow([0, 0], [0, 1], white.main, 0.5);
    return {
      //...theme.components.MuiButtonText.base,
      color: colorValue,
      textTransform:textTransform,
      fontSize:ElFontSize,

      "&:hover": {
        color: focusedColorValue,
        background: transparent.main,
        boxShadow: boxShadowValue,
        textTransform:textTransform,
      },

      "&:focus:not(:hover)": {
        color: colorValue,
        textTransform:textTransform,
      },
    };
  };

  // styles for the button with circular={true}
  const circularStyles = () => ({
    borderRadius: borderRadius.section,
  });

  // styles for the button with iconOnly={true}
  const iconOnlyStyles = () => {
    // width, height, minWidth and minHeight values

    let sizeValue = pxToRem(38);

    if (size === "small") {
      sizeValue = pxToRem(25.4);
    } else if (size === "large") {
      sizeValue = pxToRem(52);
    }

    // padding value
    let paddingValue = `${pxToRem(11)} ${pxToRem(11)} ${pxToRem(10)}`;

    if (size === "small") {
      paddingValue = pxToRem(4.5);
    } else if (size === "large") {
      paddingValue = pxToRem(16);
    }
     // color value
  const colorValue = palette.text[color] ? palette.text[color] : palette[color].main;
  const colorValue2 = palette[color] ? palette[color].main : white.main;
  const colorFocusValue = palette[color] ? palette[color].focus : white.main;
  // backgroundColor value when button is focused
    return {
      width: sizeValue,
      minWidth: sizeValue,
      height: sizeValue,
      minHeight: sizeValue,
      padding: paddingValue,
      color: colorValue? colorValue:colorValue2,
      textTransform:textTransform,

      "& .material-icons": {
        marginTop: 0,
      },

      "&:hover, &:focus, &:active": {
        transform: "none",
        color:colorFocusValue,
      },
    };
  };
// styles for the button with variant="text2button"
const text2buttonStyles = () => {

  // background color value
  const backgroundValue = color === "white" ? rgba(white.main, 0.1) : transparent.main;
  const backgroundActiveValue = palette[color] ? palette[color].main : white.main;
  // color value
  const colorValue = palette[color] ? palette[color].main : white.main;
  // backgroundColor value when button is focused
  const focusedBackgroundValue = palette[color] ? palette[color].focus : white.focus;
  // boxShadow value
  const boxShadowValue = palette[color]
    ? boxShadow([0, 0], [0, 1], palette[color].main, 0.5)
    : boxShadow([0, 0], [0, 1], white.main, 0.5);

  // border color value
  let borderColorValue = palette[color] ? palette[color].main : rgba(white.main, 0.75);

  if (color === "white") {
    borderColorValue = rgba(white.main, 0.75);
  }
  return {
    //background: transparent.main,
    color: colorValue,
    borderColor: borderColorValue,
    textTransform:textTransform,
    borderWidth: isActive ? '1px' : '0px',
    borderStyle: isActive ? 'solid' : 'none',
    background: isActive ? backgroundValue : transparent.main,

    "&:hover": { 
      background: backgroundValue,
      borderColor: colorValue,
      color: white.main,
    },

    "&:focus:not(:hover)": {
      //background: "yellow",
      background: backgroundValue,
      boxShadow: boxShadowValue,

      color: white.main,
    },

    "&:active:not(:hover)": {
      backgroundColor: backgroundActiveValue,
      color: white.main,
      opacity: 0.85,
    },

    "&:disabled": {
      //background: "blue",
      color: colorValue,
      borderColor: colorValue,
    },
  };
};
  return {
    ...(variant === "contained" && containedStyles()),
    ...(variant === "outlined" && outliedStyles()),
    ...(variant === "gradient" && gradientStyles()),
    ...(variant === "text" && textStyles()),
    ...(variant === "text2button" && text2buttonStyles()),
    ...(circular && circularStyles()),
    ...(iconOnly && iconOnlyStyles()),
  };
});
